import React, { useState } from 'react';
import { BrowserRouter as Router, Routes as Switch, Route, Link } from 'react-router-dom';
import { Navbar, Nav, NavDropdown, Container } from 'react-bootstrap';
import Home from './pages/Home';
import About from './pages/About';
import Events from './pages/Events';
import Articles from './pages/Articles';
import ArticleDetail from './pages/ArticleDetail';
import Members from './pages/Members';
import Vacancies from './pages/Vacancies';
import Book from './pages/Book';
import Signup from './pages/Signup';
import Footer from './components/Footer';
import './App.css';

function App() {
  const [expanded, setExpanded] = useState(false);

  return (
    <Router>
      <div className="App">
        <Navbar 
          bg="dark" 
          variant="dark" 
          expand="lg" 
          className="navbar-dark"
          expanded={expanded}
          onToggle={() => setExpanded(!expanded)}
        >
          <Container>
            <Navbar.Brand as={Link} to="/" className="d-flex align-items-center">
              <img src="/images/logo.jpg" alt="East London Brass Logo" className="me-2" />
              <div className="brand-content">
                <span className="brand-text">East London Brass</span>
                <div className="brand-subheader">
                  London's Premier Brass Band<br />
                  London and Southern Counties Championship Section Winners, 2025
                </div>
              </div>
            </Navbar.Brand>

            <Navbar.Toggle aria-controls="basic-navbar-nav" />
            <Navbar.Collapse id="basic-navbar-nav">
              <Nav className="ms-auto">
                <NavDropdown 
                  title="About" 
                  id="about-dropdown"
                  onClick={() => setExpanded(false)}
                >
                  <NavDropdown.Item as={Link} to="/about">About ELB</NavDropdown.Item>
                  <NavDropdown.Item as={Link} to="/members">Meet the Band</NavDropdown.Item>
                  <NavDropdown.Item as={Link} to="/book">Book the Band</NavDropdown.Item>
                </NavDropdown>

                <NavDropdown 
                  title="News & Events" 
                  id="news-dropdown"
                  onClick={() => setExpanded(false)}
                >
                  <NavDropdown.Item as={Link} to="/events">Events</NavDropdown.Item>
                  <NavDropdown.Item as={Link} to="/articles">News</NavDropdown.Item>
                </NavDropdown>

                <Nav.Link as={Link} to="/vacancies" onClick={() => setExpanded(false)}>
                  Vacancies
                </Nav.Link>
                <Nav.Link as={Link} to="/signup" onClick={() => setExpanded(false)}>
                  Sign Up
                </Nav.Link>
              </Nav>
            </Navbar.Collapse>
          </Container>
        </Navbar>

        <div className="content">
          <Switch>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/events" element={<Events />} />
            <Route path="/articles" element={<Articles />} />
            <Route path="/articles/:id" element={<ArticleDetail />} />
            <Route path="/members" element={<Members />} />
            <Route path="/vacancies" element={<Vacancies />} />
            <Route path="/book" element={<Book />} />
            <Route path="/signup" element={<Signup />} />
          </Switch>
        </div>

        <Footer />
      </div>
    </Router>
  );
}



export default App; 